import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

interface InfoTooltipWrapperProps {
  show: boolean;
  position: "top" | "bottom" | "left" | "right";
  maxWidth: string;
}

export const InfoIconButtonWrapper = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  position: relative;

  &:hover {
    background: ${COLOR_SYSTEM.get("Gray")?.[50]};
  }
`;

export const InfoTooltipWrapper = styled.div<InfoTooltipWrapperProps>`
  position: absolute;
  background: ${COLOR_SYSTEM.get("Gray")?.[800]};
  color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 12px;
  white-space: pre-line;
  min-width: 200px;
  max-width: ${({ maxWidth }) => maxWidth};
  line-height: 1.5;
  text-align: left;
  z-index: 1000;
  opacity: ${({ show }) => (show ? 1 : 0)};
  visibility: ${({ show }) => (show ? "visible" : "hidden")};
  transition: opacity 0.2s, visibility 0.2s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  /* 위치별 스타일링 */
  ${({ position }) => {
    switch (position) {
      case "top":
        return `
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: 8px;
          margin-left: 10px;
          
          &::before {
            content: "";
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border: 4px solid transparent;
            border-top-color: ${COLOR_SYSTEM.get("Gray")?.[800]};
          }
        `;
      case "bottom":
        return `
          top: 100%;
          left: 0;
          margin-top: 8px;
          
          &::before {
            content: "";
            position: absolute;
            bottom: 100%;
            left: 16px;
            border: 4px solid transparent;
            border-bottom-color: ${COLOR_SYSTEM.get("Gray")?.[800]};
          }
        `;
      case "left":
        return `
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-right: 8px;
          
          &::before {
            content: "";
            position: absolute;
            left: 100%;
            top: 50%;
            transform: translateY(-50%);
            border: 4px solid transparent;
            border-left-color: ${COLOR_SYSTEM.get("Gray")?.[800]};
          }
        `;
      case "right":
        return `
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-left: 8px;
          
          &::before {
            content: "";
            position: absolute;
            right: 100%;
            top: 50%;
            transform: translateY(-50%);
            border: 4px solid transparent;
            border-right-color: ${COLOR_SYSTEM.get("Gray")?.[800]};
          }
        `;
      default:
        return "";
    }
  }}
`;
